import { render } from "./tw-ws-progress.vue?vue&type=template&id=2d2d368c"
import script from "./tw-ws-progress.vue?vue&type=script&lang=js"
export * from "./tw-ws-progress.vue?vue&type=script&lang=js"
script.render = render

export default script